import React from 'react';
import { Helmet } from 'react-helmet-async'; // For SEO
import LIRC from '../../../components/Global/BannerCard/LIRC/LIRC';
import CyientShowcase from '../../../components/Global/BannerCard/CyientShowcase/CyientShowcase';
import THC from '../../../components/Global/BannerCard/T&HC/THC';
import MakeTheShift from '../../../components/MakeTheShift/MakeTheShift';
import ExpertiseSection3 from '../../../components/Global/BannerCard/ExpertiseSection3/ExpertiseSection3';
import Stats from '../../../components/Global/BannerCard/Stats/Stats';
import ContactPage from '../../../components/Global/BannerCard/DynamicHeader/ContactPage1';

const Mining = () => {
  const canonicalUrl = `${process.env.REACT_APP_BASE_URL || 'https://www.adithyainfinity.com'}/mining`;
  const isDevelopment = process.env.NODE_ENV === 'development';

  return (
    <>

      <Helmet>
        <html lang="en" />
        <title>
          Building a Smarter and Sustainable Energy Ecosystem | V Adithya Infinity Pvt Ltd
        </title>
        <meta
          name="description"
          content="From Finland's Energy Capital to the World--Accelerating Clean Tech, One Innovation at a Time. Explore our expertise in creating sustainable energy solutions."
        />
        <meta
          name="keywords"
          content="clean energy, sustainable energy, smart energy ecosystem, mining energy solutions, V Adithya Infinity, clean tech Finland, energy innovations"
        />
        {isDevelopment ? (
          <meta name="robots" content="noindex, nofollow" />
        ) : (
          <link rel="canonical" href={canonicalUrl} />
        )}


        <meta property="og:title" content="Building a Smarter and Sustainable Energy Ecosystem | V Adithya Infinity Pvt Ltd" />
        <meta
          property="og:description"
          content="From Finland's Energy Capital to the World--Accelerating Clean Tech, One Innovation at a Time."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta
          property="og:image"
          content="https://www.adithyainfinity.com/assets/images/mining-banner.jpg"
        />


        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Building a Smarter and Sustainable Energy Ecosystem | V Adithya Infinity Pvt Ltd" />
        <meta
          name="twitter:description"
          content="Accelerating clean tech innovation from Finland’s Energy Capital to the world."
        />
        <meta
          name="twitter:image"
          content="https://www.adithyainfinity.com/assets/images/mining-banner.jpg"
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "V Adithya Infinity Pvt Ltd",
            url: canonicalUrl,
            logo: "https://www.adithyainfinity.com/assets/images/logo.png",
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+91-9876543210",
              contactType: "Customer Support",
              areaServed: "IN",
              availableLanguage: ["English", "Hindi", "Telugu"],
            },
            sameAs: [
              "https://www.linkedin.com/company/vadithyainfinity",
              "https://www.facebook.com/vadithyainfinity",
            ],
          })}
        </script>

   
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            serviceType: "Sustainable Energy Solutions and Clean Tech Innovation",
            provider: {
              "@type": "Organization",
              name: "V Adithya Infinity Pvt Ltd",
              url: "https://www.adithyainfinity.com",
            },
            areaServed: {
              "@type": "Country",
              name: "India",
            },
            description:
              "Offering smart, sustainable energy solutions focused on clean technology innovations from Finland's Energy Capital to the world.",
          })}
        </script>
      </Helmet>

     
      <div>
        <ContactPage
          title="BUILDING A SMARTER AND SUSTAINABLE ENERGY ECOSYSTEM"
          subTitle="From Finland's Energy Capital to the World--Accelerating Clean Tech, One Innovation at a Time."
          backgroundImage="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBw8NDw0NDQ0QDQ0NEBINDQ0NEBANDQ0NFRIWFhURFRUYHSggGBolGxUVITEhJSkrOi4uFx8/OD84Nyg5OisBCgoKDg0NFQ0NFSsZFRkrLS03LSsrKy03Ny0rKystLS03LS0rNy0tLS0tNysrLTc3Ny0tNystKy03Ny0tKy0tK//AABEIAKgBLAMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAAAAQIHA//EACYQAQAABQUAAgMBAQEAAAAAAAADMdHh8AIUQVOSARFRYcGhsSH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AOIAKKACoAigApZFsAAC3LJfktyC3Vm/LWTAuJfkr+QU+/8Av8TJrX8/oEVMmZMD7/gnxn/pkwLFyxcAABAARUAAFQBAAAAUURQAMmCiZMyYirbhMmW5BS3Bky3IBbgyZbkFvwJflcmBklyTOTWv5AyS1/jOTWv5/QGSEyZkwW3CZItyZMC3BfgtyX5AQyZkwATJgqGTBT5D5QABABAUAFEVQABRARSwW5BSxk0tyCljJluQLr9pfkyYH2qZMyYC5/iZMyf6ADJmTAsFuTJgWLluUvyCoZMyYAICoAoCIAAAICgAAAoCioAKBbkQWyZMyYKJk1yYFxL8rkwBMmuTAM/xMmuTAEya5MCwmTMmC5JDJmTADJgCAKAAICAACAAoAAAKIKKAClkAUQEUEBbqyoKIAKgAqAAAAgCoAoAAIAAIAIAioDQn2AoCgAgogCgKKgAomTAFQEUTJgKIuTAEyagCAAZMFAAEVEFQFAABPtUQQABftAGkAFAAABRAFEUAD7UFQAVAAABUAAAAQFQAAEAEBU+w+wPtAAAAABfg+EX4BRPgBRBRQEBUFFEEFEFFEEFEFFEEFEAAAAAAQFD7T7A+flFQAAAAAAAAFEAVWVBRFAAAAAAAAAAAAAAAAABAVBAUQAAAAABAURQAAAAAAFQBVZUFEAURfkARQBFAE+AFEAAAEAFQAAAAAAQAAHvs4vTE8aqGzi9MTxqoAGzi9MTxqouzi9MTxqogC7OL1RPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9UTxqogC7OL1RPGqibOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAP/9k="
          highlightWord="ENERGY ECOSYSTEM"
        />
        <Stats />
        <LIRC />
        <CyientShowcase />
        <ExpertiseSection3 />
        <THC />
        <MakeTheShift />
      </div>
    </>
  );
};

export default Mining;
